var React = require('react');

function PlayBtn (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"noun_play_943870"),React.createElement("g",{"id":"Page-1","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":1},React.createElement("g",{"id":"noun_play_943870","fill":"#FFFFFF","fillRule":"nonzero"},React.createElement("path",{"d":"M46,0.5 C20.8,0.5 0.5,20.8 0.5,46 C0.5,71.2 20.8,91.5 46,91.5 C71.2,91.5 91.5,71.2 91.5,46 C91.5,20.8 71.2,0.5 46,0.5 Z M66.8,49.3 L36.5,67 C35.9,67.4 35.2,67.5 34.6,67.5 C34,67.5 33.3,67.4 32.7,67 C31.6,66.4 30.8,65.1 30.8,63.7 L30.8,28.3 C30.8,26.9 31.6,25.6 32.7,25 C33.8,24.4 35.4,24.4 36.5,25 L66.9,42.7 C68,43.3 68.7,44.6 68.7,46 C68.7,47.4 67.9,48.7 66.8,49.3 Z","id":"Shape"})))]);
}

PlayBtn.defaultProps = {"width":"92px","height":"92px","viewBox":"0 0 92 92","version":"1.1"};

module.exports = PlayBtn;

PlayBtn.default = PlayBtn;
